<div class="wrapper">
  <div class="dev-team">
    <div class="komov">
      <a href="https://github.com/AndreyKomov">
        <img src="../../../../assets/img/github.png" alt="github">
        Андрей Комов
      </a>
    </div>
    <div class="goldenkov">
      <a href="https://github.com/GoldenkovVitali">
        <img src="../../../../assets/img/github.png" alt="github">
        Виталий Голденков
      </a>
    </div>
    <div class="symonchyk">
      <a href="https://github.com/Yuliya-soul">
        <img src="../../../../assets/img/github.png" alt="github">
        Юлия Симончик
      </a>
    </div>
    <div class="boronenkov">
      <a href="https://github.com/cup0ra">
        <img src="../../../../assets/img/github.png" alt="github">
        Сергей Бороненков
      </a>
    </div>
    <div class="kravtsov">
      <a href="https://github.com/Yeeeeee1">
        <img src="../../../../assets/img/github.png" alt="github">
        Константин Кравцов
      </a>
    </div>
    <div class="titova">
      <a href="https://github.com/riatitova">
        <img src="../../../../assets/img/github.png" alt="github">
        Мария Титова
      </a>
    </div>
  </div>

  <div class="year">2021</div>

  <a href="https://rs.school/js/" class="rs-school">
    <img src="../../../../assets/img/rs_school_js.svg" alt="rs-school">
  </a>
</div>
